import { api } from "../api";

export type VehicleCustomerTransferType = {
    id: number;
    vehiclePlate: string;
    vehicleName: string;
    sourceCustomerName: string;
    sourceDepartmentName: string | null;
    targetCustomerName: string;
    targetDepartmentName: string | null;
    justification: string;
    userName: string | null;
    createdAt: string;
};

/**
 * findAllVehicleCustomerTransfers - Function that finds the history of vehicle transfers between customers (admin only)
 * /vehicles/customer-transfers?search=&page=&size=
 * method GET
 * @async-function
 */
const findAllVehicleCustomerTransfers = async (token: string, search: string, page: number, size: number) => {
    const response = await api.get(
        `/vehicles/customer-transfers`, {
        params: { search: search || undefined, page, size },
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default findAllVehicleCustomerTransfers;
